import React, { useEffect } from 'react';
import InfiniteMediaLibrary, {
  GridTileType,
} from '~/App/Modules/MyLibrary/Components/InfiniteMediaLibrary';
import EmptyUploadVideo from '~/App/Modules/MyLibrary/Components/EmptyUploadVideo';
import Empty from '~/App/Modules/MyLibrary/Components/Empty';
import { InfiniteMediaItemConfigProps } from '~/App/Modules/MyLibrary/Context/infinite-media-item-config-context';
import { AssetPageProps } from './AllDisplay';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { socialsUrl } from '~/App/Modules/Socials/util';
import { usePublishSelectModalContext } from '~/App/Modules/Testimonials/Pages/Publish/Editor/Contexts/PublishSelectModalContext';
import { PaginationMetadata, UsePagination } from '~/react-hooks/usePagination';
import { MediaLibraryAsset } from '~/App/Modules/MyLibrary/Components/InfiniteMediaLibraryItem';
import { usePublishPageContext } from '~/App/Modules/Testimonials/Pages/Publish/Editor/Contexts/PublishPageContext';

const AddSocialsButton = () => {
  return (
    <Button
      className='h-10'
      variant={ButtonVariant.Primary}
      onClick={() => (window.location.href = `${socialsUrl}/all`)}
    >
      <span className='flex items-center justify-center truncate gap-3'>
        <FontAwesomeIcon className='text-lg' icon={['fas', 'plus']} />
        Add from social
      </span>
    </Button>
  );
};

const SocialDisplay = ({
  perPage = 16,
  scrollContainerRef,
  isItemSelectDisabled,
}: AssetPageProps) => {
  const publishSelectModalContext = usePublishSelectModalContext();

  if (!publishSelectModalContext) {
    return <></>;
  }

  const {
    setPerPage,
    webAssetsPagination,
    selectedWebAssetsPagination,
    invalidateWebAssetsQueries,
    selectedIds,
    addSelectedId,
    removeSelectedId,
    filteredTags,
    getFilteredTagCollection,
    clearSelectedTags,
  } = publishSelectModalContext;

  const publishContext = usePublishPageContext();

  const savedSelectedIds = publishContext?.publish?.publishable_resources || [];

  useEffect(() => {
    setPerPage(perPage);
  }, [perPage]);

  const hasWebAssets =
    !!webAssetsPagination?.[2].total ||
    !!selectedWebAssetsPagination?.[2].total;
  const isLoading =
    webAssetsPagination?.[2].loading ||
    !!selectedWebAssetsPagination?.[2].loading;
  if (Object.keys(filteredTags).length === 0 && !isLoading && !hasWebAssets) {
    return (
      <Empty
        title="You haven't uploaded any socials yet"
        subtitle='Upload posts, comments and videos from your social media channels'
        cta={<AddSocialsButton />}
      ></Empty>
    );
  }

  const makePaginationData = () => {
    const data: UsePagination<MediaLibraryAsset, PaginationMetadata>[] = [];

    if (savedSelectedIds.length && selectedWebAssetsPagination) {
      data.push(selectedWebAssetsPagination);
    }

    if (webAssetsPagination) {
      data.push(webAssetsPagination);
    }

    return data;
  };

  return (
    <>
      <InfiniteMediaLibrary
        perPage={perPage}
        paginationData={makePaginationData()}
        onTagUpdated={invalidateWebAssetsQueries}
        orderByCreatedAt={false}
        emptyComponent={
          <EmptyUploadVideo
            tags={getFilteredTagCollection()}
            clearTags={clearSelectedTags}
            showDragAndDropBanner
          />
        }
        scrollContainerRef={scrollContainerRef}
        gridTileType={GridTileType.Dynamic}
        itemConfig={
          {
            hideInteractionStats: true,
            selectMode: true,
          } as InfiniteMediaItemConfigProps
        }
        addSelectedId={addSelectedId}
        removeSelectedId={removeSelectedId}
        selectedIds={selectedIds}
        isItemSelectDisabled={isItemSelectDisabled}
      />
    </>
  );
};

export default SocialDisplay;
